module.exports = __webpack_public_path__ + "static/media/LogoFront.a1aa15b0.png";